import DeleteContentDialog from './DeleteContentDialog';
export default DeleteContentDialog;
